import React from 'react'
import ReactHls from 'react-hls';

import { modal } from '../../core/utilities/modal'
import { buildingCameras } from '../../core/controllers/BuildingCameras'

import BuildingCamera from './BuildingCamera'

export default class BuildingCameras extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            cameras: null,
            liveFeedUri: null
        }
    }

    componentDidMount() {
        this.checkCameras(true);
        jQuery(jQuery('.scroll-attach')).slimScroll({
        	height: '450px',
			alwaysVisible: true
        });
    }

    checkCameras(forceLoad = false) {
        var self = this;
        if(this.props.hasCameras || forceLoad) {
            buildingCameras.getCameras(this.props.buildingId, function(response) {
                self.setState({
                    cameras: response.data,
                    liveFeedUri: null
                });
            });
        }
    }

    componentWillUnmount() {
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.props.hasCameras == false && nextProps.hasCameras) {
            this.checkCameras(true);
        }
    }

    componentDidUpdate() {
    }

    playVideo(id) {
        var self = this;
        buildingCameras.startPlayer(id, function(response) {
            if(response.data.error) {
                modal.showInfo("Failed to start camera feed.", "danger", "top", "center");
            } else {
                modal.showInfo("Camera feed should start playing shortly.", "success", "top", "center");
                self.setState({
                    liveFeedUri: 'https://streaming.particlespace.com' + response.data.uri
                });
            }
        });
    }

    render(){
        var self = this;
        const hasCameras = this.props.hasCameras;
        const cameras = this.state.cameras;
        const liveFeedUri = this.state.liveFeedUri;
        var length = 0;

        if(cameras != null) {
            length = cameras.length;
        }

        if(hasCameras) {
            return (
                <div class="col-md-12 camera-container">
                    <div class="card scroll-attach">
                        <div class="header">
                            <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="pe-7s-video"></i></span> Cameras - {length} online</h4>
                        </div>
                        <div class="content">
                            { liveFeedUri != null && (
                                <ReactHls width="100%" url={liveFeedUri} autoplay />
                            )}
                            { cameras != null ? (cameras.map(function(camera, index) {
                                const name = camera.name;
                                const id = camera.camera_id;
                                const level = camera.building_level;
                                return (
                                    <BuildingCamera key={index} name={name} id={id} level={level} checkCameras={self.checkCameras.bind(self)} playVideo={self.playVideo.bind(self, id)} />
                                )
                            })) : (
                                <p>Could not list any cameras.</p>
                            )}
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="pe-7s-video"></i></span> Cameras</h4>
                        <p class="category"><i class="fa fa-circle "></i> No cameras found.</p>
                    </div>
                    <div class="content">
                    </div>
                </div>
                </div>
            )
        }
    }
};


// WEBPACK FOOTER //
// app/components/Building/BuildingCameras.jsx